import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { useAuth, API } from '../App';
import axios from 'axios';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [formData, setFormData] = useState({
    phone: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  // Redirect if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      login(response.data.token);
      toast.success('Connexion réussie !');
      navigate('/admin');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Identifiants invalides');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-8">
          <h1 className="font-['Teko'] text-5xl text-[#FACC15] mb-2">
            STUNT DIRECTOR
          </h1>
          <p className="font-['Barlow'] text-gray-400 uppercase tracking-wider text-sm">
            Administration
          </p>
        </div>

        <form 
          onSubmit={handleSubmit}
          className="bg-[#09090b] border border-white/10 p-8 space-y-6"
          data-testid="admin-login-form"
        >
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-[#FACC15]/10 flex items-center justify-center">
              <Lock size={28} className="text-[#FACC15]" />
            </div>
          </div>

          <div>
            <Label className="text-[#FACC15] text-sm uppercase tracking-wider mb-2 block">
              Numéro de téléphone
            </Label>
            <Input
              type="tel"
              required
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              className="bg-black border-white/20 focus:border-[#FACC15] text-white rounded-none"
              placeholder="06 XX XX XX XX"
              data-testid="input-phone"
            />
          </div>

          <div>
            <Label className="text-[#FACC15] text-sm uppercase tracking-wider mb-2 block">
              Mot de passe
            </Label>
            <Input
              type="password"
              required
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              className="bg-black border-white/20 focus:border-[#FACC15] text-white rounded-none"
              placeholder="••••••••"
              data-testid="input-password"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#FACC15] text-black font-bold uppercase tracking-widest py-6 hover:bg-[#EAB308] transition-colors"
            data-testid="submit-login"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <div className="spinner" />
                Connexion...
              </span>
            ) : (
              'Se connecter'
            )}
          </Button>

          <p className="font-['Barlow'] text-gray-500 text-xs text-center">
            Accès réservé aux administrateurs autorisés
          </p>
        </form>

        <div className="text-center mt-6">
          <a 
            href="/"
            className="font-['Barlow'] text-gray-400 hover:text-[#FACC15] text-sm transition-colors"
          >
            ← Retour au site
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
